// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"NewsPage_breadCrumbs__qpRDy","newsSection":"NewsPage_newsSection__IcLQL"};